import React from 'react'
import { intl } from 'lang/intl'

import { TtAvatar, TtIcon } from '@23/ui-react'

import { getRole } from '../../../global/blocs/roomInfo'
import { useWebinarColors } from '../../hooks/useWebinarColors'

import GenericSpeakerList, {
  type GenericSpeakerListItemProps,
} from './GenericSpeakerList'

import './WebinarInfoSidebarSpeakerList.scss'

const SpeakerEntry = ({ speaker }: GenericSpeakerListItemProps) => {
  const { tabs } = useWebinarColors()
  const {
    id,
    title,
    company,
    name,
    avatarURL,
    link,
    linkedin,
    facebook,
    twitter,
  } = speaker
  const corporateIdentity = [title, company]
    .filter((p) => p !== undefined)
    .join(' • ')

  return (
    <div
      key={id}
      className="webinar-info-sidebar-speaker-list-item"
      style={{ borderBottomColor: tabs.contrast.transparent('5%') }}
    >
      <TtAvatar label={name} image={avatarURL} />
      <div className="speaker-info">
        <div className="speaker-info-name">{name}</div>
        <div className="speaker-info-subline">
          {corporateIdentity.length > 0 && (
            <div
              className="speaker-info-identity"
              style={{ color: tabs.highContrast.transparent('60%') }}
            >
              {corporateIdentity}
            </div>
          )}
          <div className="speaker-info-social">
            {link && (
              <a
                href={link}
                target="_new"
                aria-label={intl.formatMessage(
                  { defaultMessage: 'Website of {speakerName}' },
                  { speakerName: name }
                )}
              >
                <TtIcon name="globe" library="one" />
              </a>
            )}
            {linkedin && (
              <a
                href={linkedin}
                target="_new"
                aria-label={intl.formatMessage(
                  { defaultMessage: 'LinkedIn of {speakerName}' },
                  { speakerName: name }
                )}
              >
                <TtIcon name="linkedin" library="one/logos" />
              </a>
            )}
            {facebook && (
              <a
                href={facebook}
                target="_new"
                aria-label={intl.formatMessage(
                  { defaultMessage: 'Facebook of {speakerName}' },
                  { speakerName: name }
                )}
              >
                <TtIcon name="facebook" library="one/logos" />
              </a>
            )}
            {twitter && (
              <a
                href={twitter}
                target="_new"
                aria-label={intl.formatMessage(
                  { defaultMessage: 'X (formerly Twitter) of {speakerName}' },
                  { speakerName: name }
                )}
              >
                <TtIcon name="twitter" library="one/logos" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const WebinarInfoSidebarSpeakerList = () => {
  return (
    <div className="webinar-info-sidebar-speaker-list">
      <GenericSpeakerList
        filter={(speaker) =>
          !speaker.isHidden && speaker.creationSource !== 'guest'
        }
        renderItem={({ speaker }) => (
          <SpeakerEntry key={speaker.id} speaker={speaker} />
        )}
        placeholder={
          getRole() === 'producer'
            ? intl.formatMessage({
                defaultMessage:
                  'No speakers have been added to this event yet.',
              })
            : undefined
        }
      />
    </div>
  )
}

export default WebinarInfoSidebarSpeakerList
